import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function ArticleCard({ article, index = 0 }) {
  return (
    <motion.article
      data-testid={`article-card-${article.slug}`}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.5, delay: (index % 3) * 0.08 }}
      className="group"
    >
      <Link to={`/articles/${article.slug}`} className="block">
        <div className="overflow-hidden rounded-xl border border-brand-line bg-white shadow-sm transition-transform duration-300 group-hover:-translate-y-1">
          <div className="aspect-[16/10] overflow-hidden">
            <img
              src={article.feature_image}
              alt={article.feature_alt || article.title}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="p-5">
            <span className="text-[11px] font-semibold uppercase tracking-widest text-brand-clay">
              {article.topic}
            </span>
            <h3 className="mt-2 font-heading text-xl leading-snug text-brand-ink group-hover:text-brand transition-colors">
              {article.title}
            </h3>
            <p className="mt-2 line-clamp-2 text-sm text-brand-muted">{article.summary}</p>
            {article.author && (
              <div className="mt-4 flex items-center gap-2.5 border-t border-brand-line pt-4">
                <img src={article.author.image} alt="" className="h-8 w-8 rounded-full object-cover" />
                <span className="text-xs font-medium text-brand-ink">{article.author.name}</span>
              </div>
            )}
          </div>
        </div>
      </Link>
    </motion.article>
  );
}
